<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">Rainbow Connection Box Set</span></p>
<p class="p0">By Lynn Townsend</p>
<p class="p2"><a id="a3"></a> </p>
<p class="p2"><a href="#/006#a87">On a Roll</a></p>
<p class="p4"><a href="#/006#a88">Chapter 1</a></p>
<p class="p4"><a href="#/007#a89">Chapter 2</a></p>
<p class="p4"><a href="#/008#a90">Chapter 3</a></p>
<p class="p4"><a href="#/009#a91">Chapter 4</a></p>
<p class="p4"><a href="#/010#a92">Chapter 5</a></p>
<p class="p4"><a href="#/011#a93">Chapter 6</a></p>
<p class="p4"><a href="#/012#a94">Chapter 7</a></p>
<p class="p4"><a href="#/013#a95">Chapter 8</a></p>
<p class="p4"><span href="#/014#a96" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p4"><span href="#/015#a97" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p4"><span href="#/016#a98" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p4"><span href="#/017#a99" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p4"><span href="#/018#a100" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p4"><span href="#/019#a101" title="Link target outside of Sample">Chapter 14</span></p>
<p class="p4"><span href="#/020#a102" title="Link target outside of Sample">Chapter 15</span></p>
<p class="p4"><span href="#/021#a103" title="Link target outside of Sample">Chapter 16</span></p>
<p class="p4"><span href="#/022#a104" title="Link target outside of Sample">Chapter 17</span></p>
<p class="p4"><span href="#/023#a106" title="Link target outside of Sample">Chapter 18</span></p>
<p class="p4"><span href="#/024#a107" title="Link target outside of Sample">Chapter 19</span></p>
<p class="p4"><span href="#/025#a108" title="Link target outside of Sample">Chapter 20</span></p>
<p class="p4"><span href="#/026#a109" title="Link target outside of Sample">Chapter 21</span></p>
<p class="p4"><span href="#/027#a110" title="Link target outside of Sample">Chapter 22</span></p>
<p class="p4"><span href="#/028#a111" title="Link target outside of Sample">Chapter 23</span></p>
<p class="p4"><span href="#/029#a112" title="Link target outside of Sample">Chapter 24</span></p>
<p class="p4"><span href="#/030#a113" title="Link target outside of Sample">Chapter 25</span></p>
<p class="p4"><span href="#/031#a114" title="Link target outside of Sample">Chapter 26</span></p>
<p class="p4"> </p>
<p class="p2"><span href="#/032#a115" title="Link target outside of Sample">Got the Blues</span></p>
<p class="p4"><span href="#/032#a116" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/033#a117" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/034#a118" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/035#a119" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/036#a120" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/037#a121" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/038#a122" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p4"><span href="#/039#a123" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p4"><span href="#/040#a124" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p4"><span href="#/041#a125" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p4"><span href="#/042#a126" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p4"><span href="#/043#a127" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p4"><span href="#/044#a128" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p4"><span href="#/045#a129" title="Link target outside of Sample">Chapter 14</span></p>
<p class="p4"><span href="#/046#a130" title="Link target outside of Sample">Chapter 15</span></p>
<p class="p4"><span href="#/047#a131" title="Link target outside of Sample">Chapter 16</span></p>
<p class="p4"><span href="#/048#a132" title="Link target outside of Sample">Chapter 17</span></p>
<p class="p4"><span href="#/049#a133" title="Link target outside of Sample">Chapter 18</span></p>
<p class="p4"><span href="#/050#a134" title="Link target outside of Sample">Chapter 19</span></p>
<p class="p4"><span href="#/051#a135" title="Link target outside of Sample">Chapter 20</span></p>
<p class="p4"><span href="#/052#a136" title="Link target outside of Sample">Chapter 21</span></p>
<p class="p4"><span href="#/053#a137" title="Link target outside of Sample">Chapter 22</span></p>
<p class="p4"><span href="#/054#a138" title="Link target outside of Sample">Chapter 23</span></p>
<p class="p4"><span href="#/055#a139" title="Link target outside of Sample">Chapter 24</span></p>
<p class="p4"><span href="#/056#a140" title="Link target outside of Sample">Chapter 25</span></p>
<p class="p4"><span href="#/057#a141" title="Link target outside of Sample">Chapter 26</span></p>
<p class="p4"><span href="#/058#a142" title="Link target outside of Sample">Chapter 27</span></p>
<p class="p4"> </p>
<p class="p2"><span href="#/059#a143" title="Link target outside of Sample">A Classic Blunder</span></p>
<p class="p4"><span href="#/059#a144" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/060#a145" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/061#a146" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/062#a148" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/063#a149" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/064#a150" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/065#a152" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p4"><span href="#/066#a153" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p4"><span href="#/067#a154" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p4"><span href="#/068#a155" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p4"><span href="#/069#a156" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p4"><span href="#/070#a157" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p4"><span href="#/071#a158" title="Link target outside of Sample">Chapter 13</span></p>
<p class="p4"><span href="#/072#a159" title="Link target outside of Sample">Chapter 14</span></p>
<p class="p4"><span href="#/073#a160" title="Link target outside of Sample">Chapter 15</span></p>
<p class="p4"><span href="#/074#a161" title="Link target outside of Sample">Chapter 16</span></p>
<p class="p4"><span href="#/075#a162" title="Link target outside of Sample">Chapter 17</span></p>
<p class="p4"><span href="#/076#a163" title="Link target outside of Sample">Chapter 18</span></p>
<p class="p4"><span href="#/077#a164" title="Link target outside of Sample">Chapter 19</span></p>
<p class="p4"><span href="#/078#a165" title="Link target outside of Sample">Chapter 20</span></p>
<p class="p4"><span href="#/079#a166" title="Link target outside of Sample">Chapter 21</span></p>
<p class="p4"><span href="#/080#a167" title="Link target outside of Sample">Chapter 22</span></p>
<p class="p4"><span href="#/081#a168" title="Link target outside of Sample">Chapter 23</span></p>
<p class="p4"><span href="#/082#a169" title="Link target outside of Sample">Chapter 24</span><a href="#/#a86"></a></p>
<h1 class="h10"><a id="ncx106"></a><a id="a86"></a> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?7ea5f1b8